import formsManagerAPI from '../../config/api/formManagerAPI';
import { actionMenusInit } from '../formActionMenus/actions';
import { formatNewForm, trimName, formatFormSettingsData, formatFormCopyData } from './utils';
import {
    LOAD_FORMS,
    NEW_FORM,
    UPDATE_NEW_FORM,
    RESET_NEW_FORM,
    SELECTED_FORM,
    RESET_SELECTED_FORM,
    LOADING_START,
    LOADING_DONE
} from './constants';


export const getForms = () => {
    return (dispatch, getState) => {
        const { user } = getState();
        dispatch(loadingStart());
        formsManagerAPI.allForms(user)
            .then(res => {
                dispatch(actionMenusInit(res.data));
                dispatch(loadForms(res.data));
                dispatch(loadingDone());
            });
    };
};

export const submitNewForm = (history) => {
    return (dispatch, getState) => {
        const { forms: { newForm }, path, user } = getState();
        const formData = trimName(newForm);
        let form = formatNewForm(formData, user);

        return formsManagerAPI.createForm(form)
            .then(({ data }) => {
                dispatch(addNewForm(data));
                history.push(`${path.basePath}/${data.urlFormId}/edit`);
            });
    };
};

export const updateFormSettingsFromManager = (formData, urlFormId) => {
    return (dispatch, getState) => {
        const { user: { profile: { organizations, userName } }, forms } = getState();
        let form = formatFormSettingsData(formData, forms.selected, organizations, userName);
        return formsManagerAPI.saveFormSettings(form, urlFormId)
            .then(() => dispatch(getForms()));
    }
};

export const copyForm = (formData, urlFormId) => {
    return (dispatch, getState) => {
        const { user: { profile: { organizations, userName, userId } }, forms } = getState();
        let form = formatFormCopyData(formData, forms.selected, organizations, userName, userId);

        return formsManagerAPI.copyForm(urlFormId, form)
            .then(() => dispatch(getForms()));
    }
};

export const deleteForm = (urlFormId) => {
    return formsManagerAPI.deleteForm(urlFormId);
};

export const selectForm = (payload) => ({
    type: SELECTED_FORM,
    payload
});

export const resetSelectedForm = () => ({
    type: RESET_SELECTED_FORM
});

export const updateNewForm = (payload) => ({
    type: UPDATE_NEW_FORM,
    payload
});

export const resetNewForm = () => ({
    type: RESET_NEW_FORM
});

export const loadingStart = () => ({
    type: LOADING_START
});

export const loadingDone = () => ({
    type: LOADING_DONE
});

function loadForms (data) {
    return {
        type: LOAD_FORMS,
        payload: data
    };
}

function addNewForm (data) {
    return {
        type: NEW_FORM,
        payload: data
    };
}
